import React from "react";

import Button from "@cayuse/shared-react.components.button";
import Modal from "@cayuse/shared-react.components.modal";

import { useDictionary } from "hooks";

const ConfirmOverwriteModal = ({ open, onContinue, onCancel }) => {
	const dictionary = useDictionary("budgetBuilder.components.ConfirmOverwriteModal");

	return (
		<Modal open={open} ariaLabel={dictionary?.title || "Confirm"}>
			<Modal.Header className="whiteOnBlue">
				<h2>{dictionary?.title || "Confirm"}</h2>
			</Modal.Header>
			<Modal.Content>
				{dictionary.message || "Warning, this copy action will replace the current content of the period. Are you sure you want to continue?"}
			</Modal.Content>
			<Modal.Actions>
				<Button secondary onClick={onCancel}>{dictionary.cancel || "Cancel"}</Button>
				<Button primary onClick={onContinue}>{dictionary.continue || "Continue"}</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ConfirmOverwriteModal;
